import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/icon/iconfont.css'
import "./plugins/vue2-toast";

import Quasar from 'quasar'
import 'quasar/dist/quasar.css'




Vue.config.productionTip = false

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.use(Quasar)

import { DatePicker, Pagination } from 'element-ui';
Vue.use(DatePicker);
Vue.use(Pagination);


window.$app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
